<template>
  <div class="main dl_gray_color_bg">
    <mt-header
      :title="$t('谷歌二次验证')"
      class="dl_header_white dl_line_bottom"
      fixed
    >
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>

    <div class="container">
      <div class="swiper">
        <p class="wx_fontSize1" style="text-align: center">
          {{ $t("请输入谷歌二次验证码") }}
        </p>
      </div>
      <div class="passContainer">
        <Password v-on:end="onEnd"></Password>
      </div>
    </div>
    <VerifyPopup
      ref="refVerify"
      scene="credentials_close_google_auth"
      @onVerify="closeGoogleCheck"
    />
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import Password from "@/components/Password";
import VerifyPopup from "@/components/VerifyPopup";
import md5 from "js-md5";
import { httpGoogleCheck, httpCloseGoogleCheck } from "@/api/userCenter";
export default {
  name: "GoogleCheck",
  components: { Toast, Password, VerifyPopup },
  data() {
    return {
      result: false,
      ifNeedClose: this.$route.query.flag == "close" ? true : false,
      token: this.$route.query.token,
    };
  },
  methods: {
    goback: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    onEnd: function (val) {
      // 二级验证日常操作  验证谷歌验证码
      httpGoogleCheck({ check_num: val })
        .then((res) => {
          Toast(res.msg);
          this.result = true;
          // this.goback();
          //关闭
          if (this.ifNeedClose) {
            this.check_num = val;
            if (this.credentials) {
              this.closeGoogleCheck(this.credentials);
            } else {
              this.$refs.refVerify.show = true;
            }
          }
        })
        .catch(() => {});
    },
    closeGoogleCheck: function (credentials) {
      this.credentials = credentials;
      const payload = {
        check_num: this.check_num,
      };
      if (parseInt(Date.now() / 1000) > credentials.expiretime) {
        this.$refs.refVerify.show = true;
        return false;
      } else {
        payload.credentials = credentials.credentials;
      }
      httpCloseGoogleCheck(payload)
        .then((res) => {
          Toast(res.msg);
        })
        .catch((res) => {
          Toast(res.msg);
        });
    },
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    to.query.result = this.result;
    next();
  },
  activated: function () {
    this.result = false;
    this.ifNeedClose = this.$route.query.flag == "close" ? true : false;
  },
};
</script>

<style scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
}
.container {
  padding: 50px 10px 10px 10px;
}
.swiper {
  margin-top: 20px;
}
.swiper p {
  font-size: 12px;
  margin: 5px;
}
.passContainer {
  margin-top: 50px;
}
</style>
